// extracted by mini-css-extract-plugin
export var cardWrapper = "_67-0";